"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEventToProfile = exports.db = void 0;
const shared_1 = require("@snort/shared");
const db_1 = require("./db");
exports.db = new db_1.SnortSystemDb();
function mapEventToProfile(ev) {
    try {
        const data = JSON.parse(ev.content);
        let ret = {
            ...data,
            pubkey: ev.pubkey,
            npub: (0, shared_1.hexToBech32)("npub", ev.pubkey),
            created: ev.created_at,
            loaded: (0, shared_1.unixNowMs)(),
        };
        // sanitize non-string/number
        for (const [k, v] of Object.entries(ret)) {
            if (typeof v !== "number" && typeof v !== "string") {
                ret[k] = undefined;
            }
        }
        return ret;
    }
    catch (e) {
        console.error("Failed to parse JSON", ev, e);
    }
}
exports.mapEventToProfile = mapEventToProfile;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2FjaGUvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsMENBQXVEO0FBQ3ZELDZCQUFxQztBQUV4QixRQUFBLEVBQUUsR0FBRyxJQUFJLGtCQUFhLEVBQUUsQ0FBQztBQStDdEMsU0FBZ0IsaUJBQWlCLENBQUMsRUFBYztJQUM5QyxJQUFJO1FBQ0YsTUFBTSxJQUFJLEdBQWlCLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ2xELElBQUksR0FBRyxHQUFHO1lBQ1IsR0FBRyxJQUFJO1lBQ1AsTUFBTSxFQUFFLEVBQUUsQ0FBQyxNQUFNO1lBQ2pCLElBQUksRUFBRSxJQUFBLG9CQUFXLEVBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQyxNQUFNLENBQUM7WUFDcEMsT0FBTyxFQUFFLEVBQUUsQ0FBQyxVQUFVO1lBQ3RCLE1BQU0sRUFBRSxJQUFBLGtCQUFTLEdBQUU7U0FDSCxDQUFDO1FBRW5CLDZCQUE2QjtRQUM3QixLQUFLLE1BQU0sQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsRUFBRTtZQUN4QyxJQUFJLE9BQU8sQ0FBQyxLQUFLLFFBQVEsSUFBSSxPQUFPLENBQUMsS0FBSyxRQUFRLEVBQUU7Z0JBQ2pELEdBQVcsQ0FBQyxDQUFDLENBQUMsR0FBRyxTQUFTLENBQUM7YUFDN0I7U0FDRjtRQUNELE9BQU8sR0FBRyxDQUFDO0tBQ1o7SUFBQyxPQUFPLENBQUMsRUFBRTtRQUNWLE9BQU8sQ0FBQyxLQUFLLENBQUMsc0JBQXNCLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO0tBQzlDO0FBQ0gsQ0FBQztBQXJCRCw4Q0FxQkMifQ==